"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer id="footer" ref={footerRef} className={`bg-dark-section text-foreground-dark py-16 ${footerVisible ? "animate-reveal" : "opacity-0"}`}>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-12 md:gap-8 items-start">
          {}
          <div className="flex justify-center md:justify-start">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/unity_language_academy_logo_white.png" alt="Unity Language Academy" className="h-7" />
          </div>

          {}
          <nav className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center md:text-left">
            <div className="space-y-3">
              <h3 className="font-display text-lg font-semibold text-white mb-4">
                Courses
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/CoursesPage#ielts" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    IELTS Preparation
                  </Link>
                </li>
                <li>
                  <Link to="/CoursesPage#toefl" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    TOEFL Preparation
                  </Link>
                </li>
                <li>
                  <Link to="/CoursesPage#general-english" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    General English
                  </Link>
                </li>
                <li>
                  <Link to="/CoursesPage#german" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    German Language
                  </Link>
                </li>
              </ul>
            </div>

            <div className="space-y-3">
              <h3 className="font-display text-lg font-semibold text-white mb-4">
                Resources
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/StudentPortalPage" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    Student Portal
                  </Link>
                </li>
                <li>
                  <Link to="/BlogPage" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/AdmissionsAndContactPage#admissions" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    Admissions
                  </Link>
                </li>
                <li>
                  <Link to="/AdmissionsAndContactPage#contact" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            <div className="space-y-3">
              <h3 className="font-display text-lg font-semibold text-white mb-4">
                About
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/AboutUsPage" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/AboutUsPage#mission" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    Our Mission
                  </Link>
                </li>
                <li>
                  <Link to="/AboutUsPage#instructors" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    Instructors
                  </Link>
                </li>
                <li>
                  <Link to="/AboutUsPage#testimonials" className="text-foreground-dark hover:text-white transition-colors duration-150">
                    Testimonials
                  </Link>
                </li>
              </ul>
            </div>
          </nav>

          {}
          <div className="flex justify-center md:justify-end items-start gap-4">
            
            <Link to="https://twitter.com/unitylanguageacademy" newTab className="w-10 h-10 rounded-full border border-foreground-dark/30 flex items-center justify-center text-foreground-dark hover:bg-white hover:text-dark-section hover:border-white transition-all duration-200" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://Linkedin.com/company/unitylanguageacademy" newTab className="w-10 h-10 rounded-full border border-foreground-dark/30 flex items-center justify-center text-foreground-dark hover:bg-white hover:text-dark-section hover:border-white transition-all duration-200" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
            <Link to="https://instagram.com/unitylanguageacademy" newTab className="w-10 h-10 rounded-full border border-foreground-dark/30 flex items-center justify-center text-foreground-dark hover:bg-white hover:text-dark-section hover:border-white transition-all duration-200" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>

        {}
        <Separator className="my-8 bg-foreground-dark/20" />

        {}
        <div className="text-center text-sm text-foreground-dark/70">
          <p>
            &copy; {new Date().getFullYear()} Unity Language Academy. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}